import { ResourceDimensions, Stem } from "@examspark/types";

export const scaleByWidth = (
  width: number,
  height: number,
  desiredWidth: number,
) => {
  // return height
  const scale = desiredWidth / width;
  const _height = height * scale;
  // console.log('scale', height, width, desiredWidth, _height);

  return {
    scale: scale,
    width: desiredWidth,
    height: _height,
  };
};

export const scaleImage = (image: Stem.Image) => {
  let factor = 1;

  switch (image.metadata.scale) {
    case "@3x":
      factor = 3;
      break;
    case "@2x":
      factor = 2;
      break;
  }
  // console.log("scale", factor);
  return scaleByWidth(
    image.metadata.width,
    image.metadata.height,
    image.metadata.width / factor,
  );
};

export const scaleImageNew = (image: {
  width: number;
  height: number;
  scale: string;
}) => {
  let factor = 1;

  switch (image.scale) {
    case "@3x":
      factor = 3;
      break;
    case "@2x":
      factor = 2;
      break;
  }

  return {
    width: image.width / factor,
    height: image.height / factor,
    scale: image.scale,
  };
};

export const scaleResourceImage = (image: ResourceDimensions) => {
  if (!image.width || !image.height) return image;
  let factor = 1;

  const scale = image.scale as string | number | undefined | null;

  switch (scale) {
    case "@3x":
      factor = 3;
      break;
    case 0.5: // old style of scale
    case "@2x":
      factor = 2;
      break;
  }

  return scaleByWidth(image.width, image.height, image.width / factor);
};

export const getScaledCoordinates = (
  coords: Stem.Coordinates,
  scale: number,
) => {
  const _coords: any = {};

  if (coords.x) {
    _coords.x = Math.round(coords.x * scale);
  }
  if (coords.y) {
    _coords.y = Math.round(coords.y * scale);
  }
  if (coords.w) {
    _coords.w = Math.round(coords.w * scale);
  }
  if (coords.h) {
    _coords.h = Math.round(coords.h * scale);
  }
  if (coords.r) {
    _coords.r = Math.round(coords.r * scale);
  }

  // console.log("scaled to", _coords);
  return _coords;
};

export const getUnscaledCoordinates = (
  coords: Stem.Coordinates,
  scale: number,
) => {
  const _coords: any = {};

  if (coords.x) {
    _coords.x = Math.round(coords.x / scale);
  }
  if (coords.y) {
    _coords.y = Math.round(coords.y / scale);
  }
  if (coords.w) {
    _coords.w = Math.round(coords.w / scale);
  }
  if (coords.h) {
    _coords.h = Math.round(coords.h / scale);
  }
  if (coords.r) {
    _coords.r = Math.round(coords.r / scale);
  }

  // console.log("scaled from", _coords);
  return _coords;
};

export const getHotspotCenter = (spot: Stem.Spot) => {
  let coords: Stem.Coordinates;

  switch (spot.shape) {
    case "circle":
      coords = {
        x: spot.coords.x,
        y: spot.coords.y,
      };
      break;
    case "rect":
    default:
      coords = {
        x: spot.coords.x + (spot.coords.w ?? 0) / 2,
        y: spot.coords.y + (spot.coords.h ?? 0) / 2,
      };
      break;
  }

  return coords;
};
